export default "__VITE_ASSET__eFFWVSpv__"